import Vue from 'vue';
import ringbaPortalComponents from '@/angularBridgeCode/ringbaPortal.componentsModule';
import ReportingInsights from '@/modules/reporting/components/ReportingInsights/ReportingInsights';
import ReportingCallLogs from '@/modules/reporting/components/ReportingCallLogs/ReportingCallLogs';
import EventInsights from '@/modules/reporting/event-insights/components/EventInsights';
import ApiTokens from '@/modules/apiTokens/components';
import ExportFileLoader from '@/modules/exportFiles/components/ExportFileLoader';
import ExportJobItem from '@/modules/exportFiles/components/ExportJobItem';
import BulkBlockedNumbers from '@/modules/blockedNumbers/components/BulkBlockedNumbers';
import SearchBulkBlockedNumber from '@/modules/blockedNumbers/components/SearchBulkBlockedNumber';
import AudioAssets from '@/modules/viewAssets/components/AudioAssets';
import UserGroups from '@/modules/userGroups/components/UserGroups';
import Users from '@/modules/users/components/Users';
import TcpaShieldHistory from '@/modules/tcpaShield/components/TcpaShieldHistory';
import TargetReferences from '@/modules/targets/components/TargetReferences';
import TargetDuplicateSettings from '@/modules/targets/components/TargetDuplicateSettings';
import Login from '@/modules/auth/components/Login';
import ForgotPassword from '@/modules/auth/components/ForgotPassword';
import PasswordReset from '@/modules/auth/components/PasswordReset';
import JoinInvite from '@/modules/auth/components/JoinInvite';
import PublisherRegistrationPage from '@/modules/auth/components/OpenRegistrationPage/PublisherRegistrationPage';
import BuyerRegistrationPage from '@/modules/auth/components/OpenRegistrationPage/BuyerRegistrationPage';
import JoinPRPInvite from '@/modules/auth/components/JoinORPInvite/JoinPRPInvite';
import JoinBRPInvite from '@/modules/auth/components/JoinORPInvite/JoinBRPInvite';
import LoginHistory from '@/modules/loginSecurity/components/LoginHistory';
import TwoFactorAuth from '@/modules/twoFactorAuth/components/';
import RateLimits from '@/modules/rateLimits/components/';
import BuyerRegistrationSettings from '@/modules/openRegistration/components/BuyerRegistrationSettings';
import PublisherRegistrationSettings from '@/modules/openRegistration/components/PublisherRegistrationSettings';
import NewFeatureBanner from '@/core/components/NewFeatureBanner';
import NotificationBanner from '@/core/components/NotificationBanner/NotificationBanner.vue';
import DynamicInboundCalls from '@/modules/dynamicInboundCalls/components/DynamicInboundCalls/DynamicInboundCalls';
import DynamicInboundCallsDocumentationModal from '@/core/components/DocumentationModal/DocumentationModal';
import StatusIndicator from '@/core/components/StatusIndicator/StatusIndicator';
import HourlyDaySelector from '@/core/components/HourlyDaySelector';
import MonthlyBilling from '@/modules/billingSettings/components/MonthlyBilling';
import RechargeSettings from '@/modules/billingSettings/components/RechargeSettings';
import TransactionHistory from '@/modules/billingSettings/components/TransactionHistory';
import CreditCards from '@/modules/billingSettings/components/CreditCards';
import AccountBalance from '@/modules/billingSettings/components/AccountBalance';
import MultipleToggle from '@/core/components/MultipleToggle/MultipleToggle';
import NumbersOrdersButton from '@/modules/number/components/orders/NumbersOrdersButton';
import UrlParameters from '@/modules/urlParameters/components/UrlParameters';
import Webhooks from '@/modules/webhooks/components/Webhooks.vue';
import MacroSelectionPopover from '@/core/components/MacroSelectionPopover';
import WeekDaySelector from '@/core/components/WeekDaySelector';
import CallFlows from '@/modules/ivrs/components/CallFlows';
import CallFlowsEditor from '@/modules/ivrs/components/CallFlowsEditor';
import ManageAddresses from '@/modules/addresses/components/ManageAddresses.vue';
import RtbStatsRejectionByPublisher from '@/modules/rtbStats/components/RtbStatsRejectionByPublisher.vue';
import RtbStatsByPublisher from '@/modules/rtbStats/components/RtbStatsByPublisher.vue';
import CreateCampaign from '@/modules/campaigns/components/CreateCampaign.vue';
import NumbersListPage from '@/modules/number/pages/NumbersListPage.vue';
import RPCSettings from '@/core/components/RPCSettings';
import PredictiveRouting from '@/modules/predictiveRouting/components/PredictiveRouting';
import ManageRoutingPlan from '@/modules/routing-plans/components/ManageRoutingPlan.vue';
import RingTrees from '@/modules/ringTree/components/index';
import TrustedFormSettings from '@/core/components/TrustedFormSettings';
import JornayaSettings from '@/core/components/JornayaSettings';
import AuthConnections from '@/modules/authConnections/components/AuthConnections';
import RingTreeTargetDashboard from '@/modules/ringTreeTargets/components/RingTreeTargetDashboard';
import RingTreeTargetReferences from '@/modules/ringTreeTargets/components/RingTreeTargetReferences';
import RtbLogs from '@/modules/rtbLogs';
import RtbExport from '@/modules/rtbLogs/components/Export';
import PortalWidget from '@/core/components/PortalWidget.vue';
import Buyers from '@/modules/buyers/components/Buyers';
import HoursOfOperation from '@/core/components/HoursOfOperation/index.vue';
import Publishers from '@/modules/publisher/components';
import BulkTags from '@/modules/bulkTags/components/BulkTags';
import RevenueRecovery from '@/core/components/RevenueRecovery';
import Platforms from '@/modules/platforms/components';
import ScopedNotification from '@/core/components/ScopedNotification/ScopedNotification.vue';

import HttpHeaders from '@/core/components/HttpForm/HttpHeaders';
import HttpUrl from '@/core/components/HttpForm/HttpUrl';
import HttpBody from '@/core/components/HttpForm/HttpBody';
import InputPhoneNumber from '@/core/components/Form/InputPhoneNumber';

import CustomScoringSettings from '@/modules/dynamicInboundCalls/components/CustomScoringSettings/CustomScoringSettings';
import RingTreeTargetRequestSettings from '@/modules/ringTreeTargets/components/RequestSettings';
import RingTreeTargetConfirmationRequestSettings from '@/modules/ringTreeTargets/components/ConfirmationRequestSettings';

import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal.vue';

import AccountDetails from '@/modules/accountDetails/components/index.vue';

import AccountSettings from '@/modules/accountSettings/components/index.vue';

import UserProfile from '@/modules/userProfile/components/index.vue';
import BillingSettings from '@/modules/billingSettings/components/index.vue';
import RedirectToV3 from '@/core/components/RedirectToV3.vue';


ringbaPortalComponents.directive('vueRedirectToV3',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('RedirectToV3', RedirectToV3))
);

ringbaPortalComponents.directive('vueReportingInsights',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('ReportingInsights', ReportingInsights))
);

ringbaPortalComponents.directive('vueEventInsights',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('EventInsights', EventInsights))
);

ringbaPortalComponents.directive('vueReportingCallLogs',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('ReportingCallLogs', ReportingCallLogs))
);

ringbaPortalComponents.directive('vueApiTokens',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('ApiTokens', ApiTokens))
);

ringbaPortalComponents.directive('exportJobItem',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('ExportJobItem', ExportJobItem))
);

ringbaPortalComponents.directive('exportFileLoader',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('ExportFileLoader', ExportFileLoader))
);

ringbaPortalComponents.directive('audioAssets',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('AudioAssets', AudioAssets))
);

ringbaPortalComponents.directive('userGroups',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('UserGroups', UserGroups))
);

ringbaPortalComponents.directive('vueUsers',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('Users', Users))
);

ringbaPortalComponents.directive('bulkBlockedNumbers',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('BulkBlockedNumbers', BulkBlockedNumbers))
);

ringbaPortalComponents.directive('searchBulkBlockedNumber',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('SearchBulkBlockedNumber', SearchBulkBlockedNumber))
);

ringbaPortalComponents.directive('urlParameters',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('urlParameters', UrlParameters))
);

ringbaPortalComponents.directive('callFlows',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('callFlows', CallFlows))
);

ringbaPortalComponents.directive('callFlow',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('callFlow', CallFlowsEditor))
);

ringbaPortalComponents.directive('webhooks',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('Webhooks', Webhooks))
);

ringbaPortalComponents.directive('tcpaShieldHistory',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('TcpaShieldHistory', TcpaShieldHistory))
);

ringbaPortalComponents.directive('vueNewFeatureBanner',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('NewFeatureBanner', NewFeatureBanner))
);

ringbaPortalComponents.directive('vueNotificationBanner',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('NotificationBanner', NotificationBanner))
);

ringbaPortalComponents.directive('vueDynamicInboundCalls',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('DynamicInboundCalls', DynamicInboundCalls))
);

ringbaPortalComponents.directive('vueDynamicInboundCallsDocumentationModal',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('DynamicInboundCallsDocumentationModal', DynamicInboundCallsDocumentationModal))
);

ringbaPortalComponents.directive('vueStatusIndicator',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('StatusIndicator', StatusIndicator))
);

ringbaPortalComponents.directive('vueTargetReferences',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('TargetReferences', TargetReferences))
);
ringbaPortalComponents.directive('vueTargetDuplicateSettings',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('TargetDuplicateSettings', TargetDuplicateSettings))
);

ringbaPortalComponents.directive('vueHourlyDaySelector',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('HourlyDaySelector', HourlyDaySelector))
);

ringbaPortalComponents.directive('vueWeekDaySelector',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('WeekDaySelector', WeekDaySelector))
);

ringbaPortalComponents.directive('vueRpcSettings',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('RPCSettings', RPCSettings))
);

ringbaPortalComponents.directive('vueRevenueRecovery',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('RevenueRecovery', RevenueRecovery))
);

ringbaPortalComponents.directive('predictiveRouting',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('PredictiveRouting', PredictiveRouting))
);

ringbaPortalComponents.directive('vueRoutingPlan',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('ManageRoutingPlan', ManageRoutingPlan))
);

ringbaPortalComponents.directive('ringTrees',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('RingTrees', RingTrees))
);

ringbaPortalComponents.directive('vuePublishers',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('Publishers', Publishers))
);

ringbaPortalComponents.directive('vueTrustedFormSettings',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('TrustedFormSettings', TrustedFormSettings))
);

ringbaPortalComponents.directive('vueJornayaSettings',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('JornayaSettings', JornayaSettings))
);

ringbaPortalComponents.directive('vueMultipleToggle',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('MultipleToggle', MultipleToggle))
);

ringbaPortalComponents.directive('vueMacroSelectionPopover',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('MacroSelectionPopover', MacroSelectionPopover))
);

ringbaPortalComponents.directive('vueLogin',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('Login', Login))
);

ringbaPortalComponents.directive('vueForgotPassword',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('ForgotPassword', ForgotPassword))
);

ringbaPortalComponents.directive('vuePasswordReset',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('PasswordReset', PasswordReset))
);

ringbaPortalComponents.directive('vueJoinInvite',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('JoinInvite', JoinInvite))
);

ringbaPortalComponents.directive('vuePrp',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('PublisherRegistrationPage', PublisherRegistrationPage))
);

ringbaPortalComponents.directive('vueBrp',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('BuyerRegistrationPage', BuyerRegistrationPage))
);

ringbaPortalComponents.directive('vueJoinPrpInvite',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('JoinPRPInvite', JoinPRPInvite))
);

ringbaPortalComponents.directive('vueJoinBrpInvite',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('JoinBRPInvite', JoinBRPInvite))
);

ringbaPortalComponents.directive('vueLoginHistory',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('LoginHistory', LoginHistory))
);

ringbaPortalComponents.directive('vueTwoFactorAuth',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('VueTwoFactorAuth', TwoFactorAuth))
);

ringbaPortalComponents.directive('vueRateLimits',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('VueRateLimits', RateLimits))
);

ringbaPortalComponents.directive('vueBuyerRegistrationSettings',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('VueBuyerRegistrationSettings', BuyerRegistrationSettings))
);

ringbaPortalComponents.directive('vuePublisherRegistrationSettings',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('VuePublisherRegistrationSettings', PublisherRegistrationSettings))
);

ringbaPortalComponents.directive('vueNumbersOrders',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('VueNumbersOrders', NumbersOrdersButton))
);
ringbaPortalComponents.directive('vueMonthlyBilling',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('VueMonthlyBilling', MonthlyBilling))
);
ringbaPortalComponents.directive('vueRechargeSettings',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('VueRechargeSettings', RechargeSettings))
);
ringbaPortalComponents.directive('vueTransactionHistory',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('VueTransactionHistory', TransactionHistory))
);
ringbaPortalComponents.directive('vueCreditCards',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('VueCreditCards', CreditCards))
);

ringbaPortalComponents.directive('vueAccountBalance',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('VueAccountBalance', AccountBalance))
);

ringbaPortalComponents.directive('vueAddresses',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('VueAddresses', ManageAddresses))
);

ringbaPortalComponents.directive('rtbStatsRejectionByPublisher',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('RtbStatsRejectionByPublisher', RtbStatsRejectionByPublisher))
);
ringbaPortalComponents.directive('rtbStatsByPublisher',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('RtbStatsByPublisher', RtbStatsByPublisher))
);


ringbaPortalComponents.directive('vueNumbersList',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('VueNumbersList', NumbersListPage))
);

ringbaPortalComponents.directive('vueCreateCampaign',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('VueCreateCampaign', CreateCampaign))
);

ringbaPortalComponents.directive('vueAuthConnections',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('VueAuthConnections', AuthConnections))
);

ringbaPortalComponents.directive('ringTreeTargetDashboard',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('RingTreeTargetDashboard', RingTreeTargetDashboard))
);

ringbaPortalComponents.directive('rtbLogs',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('RtbLogs', RtbLogs))
);
ringbaPortalComponents.directive('rtbExport',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('RtbExport', RtbExport))
);

ringbaPortalComponents.directive('vueNumberPoolsList',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('VueNumberPoolsList', () => import('@/modules/number/pages/NumberPoolsList.vue')))
);

ringbaPortalComponents.directive('vueChangelogObjectButtonAction',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('VueChangelogObjectButtonAction', () => import(/* webpackChunkName: "changelog" */ '@/core/components/ChangeLog/ChangeLogObjectButtonAction.vue')))
);

ringbaPortalComponents.directive('vueChangelog',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('VueChangelog', () => import(/* webpackChunkName: "changelog" */ '@/core/components/ChangeLog/ChangeLog.vue')))
);

ringbaPortalComponents.directive('portalWidget',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('PortalWidget', PortalWidget))
);

ringbaPortalComponents.directive('vueHttpHeaders',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('HttpHeaders', HttpHeaders))
);

ringbaPortalComponents.directive('vueHttpUrl',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('HttpUrl', HttpUrl))
);

ringbaPortalComponents.directive('vueHttpBody',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('HttpBody', HttpBody))
);

ringbaPortalComponents.directive('vueInputPhoneNumber',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('InputPhoneNumber', InputPhoneNumber))
);

ringbaPortalComponents.directive('vueBuyers',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('Buyers', Buyers)));

ringbaPortalComponents.directive('vueHoursOfOperation',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('HoursOfOperation', HoursOfOperation)));

ringbaPortalComponents.directive('customScoringSettings',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('CustomScoringSettings', CustomScoringSettings))
);

ringbaPortalComponents.directive('vueRingTreeTargetRequestSettings',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('RingTreeTargetRequestSettings', RingTreeTargetRequestSettings))
);

ringbaPortalComponents.directive('vueRingTreeTargetConfirmationRequestSettings',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('RingTreeTargetConfirmationRequestSettings', RingTreeTargetConfirmationRequestSettings))
);

ringbaPortalComponents.directive('vueRingTreeTargetReferences',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('RingTreeTargetReferences', RingTreeTargetReferences))
);

ringbaPortalComponents.directive('bulkTags',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('BulkTags', BulkTags))
);

ringbaPortalComponents.directive('vueConfirmationModal',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('ConfirmationModal', ConfirmationModal))
);

ringbaPortalComponents.directive('vueAccountDetails',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('AccountDetails', AccountDetails))
);


ringbaPortalComponents.directive('vueAccountSettings',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('AccountSettings', AccountSettings))
);

ringbaPortalComponents.directive('vueUserProfile',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('UserProfile', UserProfile))
);

ringbaPortalComponents.directive('vueBillingSettings',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('BillingSettings', BillingSettings))
);

ringbaPortalComponents.directive('vuePlatforms',
  /** @ngInject */
  createVueComponent => createVueComponent(Vue.component('Platforms', Platforms))
);

ringbaPortalComponents.directive('vueScopedNotification',
  /** @ngInject */
  createVueComponent => createVueComponent(
    Vue.component('ScopedNotification', ScopedNotification),
    ['message', 'type']
  )
);
